import { ReactElement } from 'react';
import { QFlex, QResourceIcon, QSpinner, QText, QTooltip } from '@qualio/ui-components';
import { useResolveRelatedRecords } from '../../../hooks/useResolveRelatedRecords';

const ActiveRelatedRecordFilter = ({ value }: { value: unknown }): ReactElement => {
  const qri = value as string;
  const { relatedRecords, isLoading } = useResolveRelatedRecords([qri]);

  if (isLoading) {
    return <QSpinner size="sm" />;
  }

  const record = relatedRecords[0];
  const code = record?.code ?? '';
  const name = record?.name ?? '';
  const label = code || name;

  const content = (
    <QFlex as="span" display="inline-flex" align="center" gap={1} verticalAlign="middle">
      {record?.resource && <QResourceIcon domain={record.resource} />}
      <QText as="span">{label}</QText>
    </QFlex>
  );

  return name ? <QTooltip label={name}>{content}</QTooltip> : content;
};

export default ActiveRelatedRecordFilter;
